import React from 'react';
import { Box } from '@myob/myob-widgets';
import { ProductData } from 'hooks/useGetProduct/types';
import { AI_BAS_ADD_ON_IDS } from '../../../constants';
import { AddOnView } from './addOnView/AddOnView';
import style from './AddOn.module.scss';

export type AddOnProps = {
  addOnId: string;
  productData: ProductData;
};

export const AddOn: React.FC<AddOnProps> = ({ addOnId, productData }) => (
  <Box
    className={style.addOnList}
    data-testid='add-on-list'
    display='flex'
    flexDirection='column'
  >
    {AI_BAS_ADD_ON_IDS.includes(addOnId) && <AddOnView productData={productData} />}
  </Box>
);
